<template>
  <v-card class="d-flex flex-column" height="100vh">
    <v-sheet class="flex-grow-1 overflow-auto">
      <v-toolbar color="primary" density="compact" class="px-4">
        <v-icon icon="mdi-file-document-multiple" class="mr-2"></v-icon>
        <v-toolbar-title class="text-subtitle-1 font-weight-medium">
          {{ record?.id }}
          <span v-if="record?.title" class="font-weight-regular opacity-90">
        - {{ record.title }}
      </span>
        </v-toolbar-title>
      </v-toolbar>
      <v-tabs
          v-model="currentEditTab"
          :items="editTabs"
          align-tabs="center"
          color="primary"
          height="60"
          slider-color="primary"
      >
        <template v-slot:tab="{ item }">
          <v-tab
              :disabled="record.tasks.length == 0 && item.value === 'tab-3'"
              :prepend-icon="item.icon"
              :text="item.text"
              :value="item.value"
              class="text-none"
          ></v-tab>
        </template>

        <template v-slot:item="{ item }">
          <v-tabs-window-item :value="item.value" class="pa-4">
            <OrderInformationDialog v-if="item.value == 'tab-1'" v-model="record"
                                    :readonly="useGlobalSetting().globalReadonly"/>
            <TaskPanels v-if="item.value == 'tab-2'" ref="aufgabenFormRef" v-model="record"
                        :readonly="useGlobalSetting().globalReadonly"/>
            <TimeLine v-if="item.value == 'tab-3'" v-model="record"/>
          </v-tabs-window-item>
        </template>
      </v-tabs>
    </v-sheet>

    <v-card-actions class="bg-surface-light">
      <v-btn variant="plain" @click="cancel(); currentEditTab = 'tab-1';">
        <v-icon color="red" icon="mdi-cancel" start></v-icon>
        Abbrechen
      </v-btn>

      <v-spacer></v-spacer>
      <v-btn :disabled="!useGlobalSetting().hasChanged" text="Save" @click="submit();">
        <v-icon color="green" icon="mdi-checkbox-marked-circle" start></v-icon>
        Speichern
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>

import TimeLine from "@/components/misc/TimeLine.vue";
import TaskPanels from "@/components/misc/TaskPanels.vue";
import OrderInformationDialog from "@/components/dialogs/OrderInformationDialog.vue";
import {shallowRef} from "vue";
import {Order, updateOrder} from "@/types/Order";
import {useGlobalSetting} from "@/lib/utils";

const record = defineModel<Order>();

const props = defineProps({
  onClose: {
    type: Function,
    required: true
  }
});


interface EditTab {
  icon: string;
  text: string;
  value: string;
}

const currentEditTab = shallowRef<string>('tab-1')
const editTabs: EditTab[] = [
  {
    icon: 'mdi mdi-information-slab-box',
    text: 'Information',
    value: 'tab-1'
  },
  {
    icon: 'mdi mdi-book',
    text: 'Aufgaben',
    value: 'tab-2'
  },
  {
    icon: 'mdi mdi-book-clock-outline',
    text: 'Zeitplan',
    value: 'tab-3'
  },
]

function cancel() {
  useGlobalSetting().hasChanged = false;
  props.onClose?.();
}

function submit() {
  updateOrder(record.value)
}

</script>